import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import administrator from './administrator'
import app from './app'
import reference from './reference'
import applications from './applications'
import agreements from './agreements'
import warehouse from './warehouse'
import content from './content'
import listAppeal from './listAppeal'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    ...administrator,
    ...app,
    ...reference,
    ...applications,
    ...agreements,
    ...warehouse,
    ...content,
    ...listAppeal,
    {
      path: '/',
      redirect: ()=>{
        return {
          name: "applications-material"
        }
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/PrivacyPolicy.vue'),
      meta: {
        pageTitle: 'Privacy policy',
        layout: 'full',
        action: 'read',
      }
    },
  ],
})





router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      if(to.name == 'privacy'){
        next()
      }else{
        next('/login')
      }
    } else {
      // If logged in => not authorized
      next({ name: 'not-authorized' })
    }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next('/')
    // next({ name: userData.profile.home_route ? userData.profile.home_route : 'inspected-objects' })
  }

  return next()
})






// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
